var _path, _mask, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSunnyPartlyCloudy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.043 51.3434C95.8247 72.9053 82.2199 94.2631 60.6581 99.043C39.0945 103.825 17.7367 90.2198 12.9569 68.6561C8.17521 47.0942 21.7818 25.7381 43.3419 20.9564C64.9055 16.1765 86.2632 29.7796 91.043 51.3434Z",
    fill: "#FFC318"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-1",
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 45,
    width: 71,
    height: 50,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 42,
    y: 45,
    width: 71,
    height: 50
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1201 90.9989C99.6713 90.8847 109 81.5269 109 70C109 58.402 99.556 49 87.9062 49C77.7013 49 69.1889 56.2145 67.2345 65.7999H58.6C51.6412 65.7999 46 71.4411 46 78.3999C46 85.3587 51.6412 90.9999 58.6 90.9999H87.8433C87.8643 91 87.8853 91 87.9062 91C87.9275 91 87.9487 91 87.9699 90.9999C88.02 90.9999 88.0701 90.9996 88.1201 90.9989Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1201 90.9989C99.6713 90.8847 109 81.5269 109 70C109 58.402 99.556 49 87.9062 49C77.7013 49 69.1889 56.2145 67.2345 65.7999H58.6C51.6412 65.7999 46 71.4411 46 78.3999C46 85.3587 51.6412 90.9999 58.6 90.9999H87.8433C87.8643 91 87.8853 91 87.9062 91C87.9275 91 87.9487 91 87.9699 90.9999C88.02 90.9999 88.0701 90.9996 88.1201 90.9989Z",
    fill: "#CCCCCC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1201 90.9989C99.6713 90.8847 109 81.5269 109 70C109 58.402 99.556 49 87.9062 49C77.7013 49 69.1889 56.2145 67.2345 65.7999H58.6C51.6412 65.7999 46 71.4411 46 78.3999C46 85.3587 51.6412 90.9999 58.6 90.9999H87.8433C87.8643 91 87.8853 91 87.9062 91C87.9275 91 87.9487 91 87.9699 90.9999C88.02 90.9999 88.0701 90.9996 88.1201 90.9989Z",
    stroke: "white",
    strokeWidth: 8,
    mask: "url(#path-3-outside-1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunnyPartlyCloudy);
export default __webpack_public_path__ + "static/media/sunny_partly_cloudy.d11d50a85de350bed237b931cb406a75.svg";
export { ForwardRef as ReactComponent };